import React, { useCallback } from "react";
import { MaterialPagination } from "./../../CustomPagination";
import WithSelect from "../../select";
import comma from "../../../cores/comma";
import { useTranslation } from "react-i18next";
import throttle from "lodash/throttle";
import { IconRefresh } from "@mzc-cloudplex/icons";
import { Grid, IconButton, Tooltip, Typography } from "@mzc-pdc/ui";

const CpmPagination = (props) => {
    const {
        onChangeLimit,
        onChangeOffset,
        limit = 0,
        offset = 0,
        totalCount = 0,
        maxCount,
        limitOptions = [],
        onRefresh,
        size = "",
        showTotalCount = false,
        showOnlyRefresh = false,
        showLimitChange = true,
        isViewMore = false,
        nextToken = "",
        onClickViewMore,
    } = props;
    const { t } = useTranslation();

    const onClickRefresh = useCallback(
        (event) => {
            if (onRefresh) onRefresh(event);
        },
        [onRefresh],
    );

    // const onClickChangeOffset = useCallback((option) => {
    //     if(onChangeOffset && offset !== option - 1) {
    //         onChangeOffset(option);
    //     }
    // }, [onChangeOffset]);
    const onClickChangeOffset = (option) => {
        if (onChangeOffset && offset !== option - 1) {
            onChangeOffset(option);
        }
    };

    const onClickLimitChange = (option) => {
        if (onChangeLimit && limit !== option.value) {
            onChangeLimit(option.value);
        }
    };

    return (
        <React.Fragment>
            <Tooltip title={`${t("common::label::Refresh")}`}>
                <IconButton circled onClick={onClickRefresh}>
                    <IconRefresh size={16} />
                </IconButton>
            </Tooltip>

            <div className="wrap-pagination" style={{ display: `flex`, gap: 8 }}>
                {showTotalCount && (
                    <Grid item sx={{ display: "flex", alignItems: "center" }}>
                        <Typography variant={"body1_400"}>
                            {`${totalCount === 0 ? 0 : offset + 1}-${
                                offset + limit > totalCount ? totalCount : offset + limit
                            }`}{" "}
                            {t(`common::label::of`, "of")} {totalCount ? comma(totalCount.toString()) : ""}
                            {maxCount && (maxCount <= totalCount ? "+" : "")}
                        </Typography>
                    </Grid>
                )}
                <MaterialPagination
                    activePage={offset / limit + 1}
                    totalItemsCount={totalCount}
                    itemsCountPerPage={limit}
                    onChange={onClickChangeOffset}
                    onClickViewMore={onClickViewMore}
                    size={size}
                    isViewMore={isViewMore}
                    nextToken={nextToken}
                />
                {showLimitChange && (
                    <WithSelect
                        defaultValue={limit}
                        options={limitOptions}
                        size={size ? size : ""}
                        onChange={onClickLimitChange}
                    />
                )}
            </div>
        </React.Fragment>
    );
};

export default CpmPagination;
